import React from 'react';

const InstagramPreview = () => {

    return (
        <div className="instagram-preview-section">
            <div className="container">
                <div className="section-title text-center mb-40">
                    <h4>Ακολουθήστε μας στο Instagram</h4>
                    <h2>
                        <a href="https://www.instagram.com/ratatouille_cuisine_serres/" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
                            @ratatouille_cuisine_serres
                        </a>
                    </h2>
                </div>
                <div
                    className="elfsight-app-4f7c8c9a-c9f0-469b-9df5-8138632b6c01"
                    data-elfsight-app-lazy
                />
                <div className="text-center mt-40">
                    <a href="https://www.instagram.com/ratatouille_cuisine_serres/" target="_blank" rel="noreferrer" className="l-btn">Δείτε περισσότερα</a>
                </div>
            </div>
        </div>
    );
};

export default InstagramPreview;
